import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef68d4ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = { class: "package-info" }
const _hoisted_3 = { class: "package-code" }
const _hoisted_4 = { class: "address-container" }
const _hoisted_5 = { class: "address-info" }
const _hoisted_6 = {
  key: 0,
  class: "item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 收件国家/地区 ", -1))
const _hoisted_8 = { class: "view-item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 国内快递单号 ", -1))
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 包裹备注 ", -1))
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 保价金额 ", -1))
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "invoice" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 运费 ", -1))
const _hoisted_22 = { class: "text" }
const _hoisted_23 = {
  key: 0,
  class: "item"
}
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "item large" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 总计 ", -1))
const _hoisted_28 = { class: "text price" }
const _hoisted_29 = { class: "container" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "item package-attr-info" }
const _hoisted_32 = { class: "package-num" }
const _hoisted_33 = { class: "num" }
const _hoisted_34 = {
  key: 0,
  class: "badge"
}
const _hoisted_35 = { class: "price" }
const _hoisted_36 = { class: "express" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "线路", -1))
const _hoisted_38 = { class: "text" }
const _hoisted_39 = {
  key: 0,
  class: "item latest-tracking"
}
const _hoisted_40 = { class: "message" }
const _hoisted_41 = { class: "time" }
const _hoisted_42 = {
  key: 0,
  class: "footer-ctrl g-fixed"
}
const _hoisted_43 = {
  key: 0,
  class: "remind-pay"
}
const _hoisted_44 = {
  key: 1,
  class: "invoice"
}
const _hoisted_45 = { class: "item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 运费 ", -1))
const _hoisted_47 = { class: "text" }
const _hoisted_48 = {
  key: 0,
  class: "item"
}
const _hoisted_49 = { class: "label" }
const _hoisted_50 = { class: "text" }
const _hoisted_51 = { class: "footer-bar" }
const _hoisted_52 = { class: "bar-price" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合计", -1))
const _hoisted_54 = { class: "price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Payment = _resolveComponent("Payment")!

  return (_ctx.packageInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.packageInfo.packageNum), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "icon_address"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.packageInfo.firstname) + " " + _toDisplayString(_ctx.packageInfo.lastname), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.packageInfo.mobile), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.packageInfo.address1) + " " + _toDisplayString(_ctx.packageInfo.address2 || '') + ", " + _toDisplayString(_ctx.packageInfo.city) + ", " + _toDisplayString(_ctx.packageInfo.state) + " " + _toDisplayString(_ctx.packageInfo.zipcode) + " , " + _toDisplayString(_ctx.packageInfo.country), 1)
            ])
          ]),
          (_ctx.displayCountryInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "country-icon",
                    src: _ctx.displayCountryInfo.icon
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", null, _toDisplayString(_ctx.displayCountryInfo.nameCn), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.packageInfo.logisticsCode || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.packageInfo.note || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, " ¥" + _toDisplayString(_ctx.packageInfo.declareAmount), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.packageInfo.basePrice ? '¥' + _ctx.packageInfo.basePrice : '仓库测算中'), 1)
            ]),
            (_ctx.packageInfo.declarePrice > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(" 保价 "),
                    _createVNode(_component_Icon, {
                      onClick: _ctx.showDeclareTips,
                      class: "declare-explanation",
                      icon: "btn_explanation"
                    }, null, 8, ["onClick"])
                  ]),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.packageInfo.declarePrice
                ? '¥' + _ctx.packageInfo.declarePrice
                : '仓库测算中'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.packageInfo.price !== null ? '¥' + _ctx.packageInfo.price : '仓库测算中'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageInfo.packageAttr, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "package-item g-card",
              key: item.package_attr_num,
              onClick: ($event: any) => (_ctx.toDetail(item))
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Icon, {
                    class: "icon",
                    icon: "icon_order"
                  }),
                  _createElementVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(item.package_attr_num) + " ", 1),
                    (!item.is_clicked)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Icon, {
                    class: "open-it",
                    icon: "btn_arrow_right"
                  })
                ]),
                _createElementVNode("div", _hoisted_35, _toDisplayString(item.price !== null ? '¥' + item.price : '仓库测算中'), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, _toDisplayString(item.express ? item.express.title : '-'), 1)
              ]),
              (item.latest_tracking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(item.latest_tracking.event), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(item.latest_tracking.time), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_30))
          }), 128))
        ]),
        (_ctx.packageInfo.statusPay === 2 && _ctx.packageInfo.price)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              (_ctx.packageInfo.price)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, " 为确保您的包裹及时寄出，请及时付款 "))
                : _createCommentVNode("", true),
              (_ctx.packageInfo.price)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.packageInfo.basePrice ? '¥' + _ctx.packageInfo.basePrice : '仓库测算中'), 1)
                    ]),
                    (_ctx.packageInfo.declarePrice > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createTextVNode(" 保价 "),
                            _createVNode(_component_Icon, {
                              onClick: _ctx.showDeclareTips,
                              class: "declare-explanation",
                              icon: "btn_explanation"
                            }, null, 8, ["onClick"])
                          ]),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.packageInfo.declarePrice
                ? '¥' + _ctx.packageInfo.declarePrice
                : '仓库测算中'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.packageInfo.price ? '¥' + _ctx.packageInfo.price : '仓库测算中'), 1)
                ]),
                _createElementVNode("div", {
                  class: "g-button g-button-danger",
                  "hover-class": "hover",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startPay(_ctx.packageInfo.id)))
                }, " 立即支付 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showPayment)
          ? (_openBlock(), _createBlock(_component_Payment, {
              key: 1,
              "package-ids": _ctx.payPackageIds,
              onClose: _ctx.closePayment,
              onSuccess: _ctx.paySuccess
            }, null, 8, ["package-ids", "onClose", "onSuccess"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}